import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const toPublisherAction = createAsyncThunk(
    'total-publisher',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-publisher`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const toPublisherSlice = createSlice({
    name: 'total-publisher',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(toPublisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(toPublisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(toPublisherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const toPublisherReducer = toPublisherSlice.reducer
